/**
 * Badkern Variantenmodell-Controller (Phase 4, 09.10.2026)
 *
 * 4.2 Sofort-Anzeige: Beim Tipp auf eine Option werden Preis, Statt-Preis, Ersparnis,
 *     „Ihre Auswahl“/Lagerstatus, Sticky-Leiste, Kaufknopf und das versteckte Feld
 *     input[name=id] SOFORT aus vorgerenderten Vorlagen (<template data-bk-…>) gesetzt.
 *     Horizon lädt danach wie bisher die Seite nach und bestätigt mit demselben Markup.
 *     Die Watt-/Raumgrößen-Box (varianten-leistung.js) liest input[name=id] und zieht
 *     dadurch von selbst nach.
 * 4.1 Größe behalten: Die Farb-/Betriebsart-Chips (Links auf Schwesterprodukte) bekommen
 *     ?variant=<id> der gleichen bzw. nächstliegenden verfügbaren Größe; auf der Zielseite
 *     erscheint bei Abweichung ein kurzer Hinweis (Parameter bk_von).
 *
 * Sicherheitsregeln (Inhaber 09.10.): kein MutationObserver, kein setInterval, keine
 * synthetischen Events, kein .checked/.click(), kein disabled für den Wartezustand,
 * jede Schreibrunde per data-bk-key idempotent (nie innerHTML vergleichen), jeder Handler
 * in try/catch – bei einem Fehler schaltet sich der Controller ab (window.__bkVM.aus) und
 * Horizon läuft wie ohne ihn. Der Kaufknopf bleibt in jedem Fall bedienbar.
 */
(function () {
  'use strict';
  if (window.__bkVM) return;
  window.__bkVM = { aus: false, version: 1 };

  var BUSY_MS = 3000;
  var modell = null;
  var gen = 0;
  var busyTimer = null;

  /* ───────── Hilfen ───────── */
  function normal(s) {
    return String(s == null ? '' : s).toLowerCase().replace(/×/g, 'x').replace(/\s+/g, '');
  }

  function lesen() {
    var el = document.querySelector('script[data-bk-modell]');
    if (!el) return null;
    try {
      var m = JSON.parse(el.textContent);
      if (!m || !m.varianten || !m.varianten.length || !m.optionen) return null;
      return m;
    } catch (e) {
      return null;
    }
  }

  function sicherung(err) {
    try { console.warn('[varianten-modell] abgeschaltet:', err); } catch (e) {}
    window.__bkVM.aus = true;
    busyAus();
  }

  function picker() {
    return document.querySelector('variant-picker[data-template-product-match="true"]');
  }

  /** Gewählte Werte je Optionsposition aus den Radios: {1: 'wert', 2: 'wert', …} */
  function auswahl(vp) {
    var radios = vp.querySelectorAll('fieldset input[type="radio"]:checked');
    if (!radios.length) return null;
    var r = {};
    for (var i = 0; i < radios.length; i++) {
      var id = radios[i].getAttribute('data-input-id') || '';
      var pos = parseInt(id.split('-')[0], 10);
      if (!pos) {
        var fs = radios[i].getAttribute('data-fieldset-index');
        pos = fs == null ? NaN : parseInt(fs, 10) + 1;
      }
      if (!pos) return null;
      r[pos] = normal(radios[i].value);
    }
    return r;
  }

  function varianteZu(liste, werte) {
    for (var i = 0; i < liste.length; i++) {
      var v = liste[i], passt = true;
      for (var p = 1; p <= 3; p++) {
        if (werte[p] === undefined) continue;
        if (normal(v['o' + p]) !== werte[p]) { passt = false; break; }
      }
      if (passt) return v;
    }
    return null;
  }

  function setzeText(el, text) {
    if (el && el.textContent !== text) el.textContent = text;
  }

  /** Ersten nicht-leeren Textknoten eines Elements ersetzen (Kaufknopf-Beschriftung) */
  function setzeErstenText(el, text) {
    for (var i = 0; i < el.childNodes.length; i++) {
      var n = el.childNodes[i];
      if (n.nodeType === 3 && n.nodeValue.trim()) {
        if (n.nodeValue.trim() !== text) n.nodeValue = text;
        return;
      }
    }
  }

  /** data-bk-key auf den Sofort-Anzeige-Zielen setzen (id) oder löschen (null).
      Nötig, weil Horizon nach „Kombination gibt es nicht“ Nil-Markup einsetzt, die Elemente
      selbst (und damit der Schlüssel) aber bestehen bleiben (Gegencheck 09.10.). */
  function schluesselSetzen(id) {
    var ziele = document.querySelectorAll('preis-ersparnis, sticky-add-to-cart, auswahl-verfuegbarkeit');
    for (var i = 0; i < ziele.length; i++) {
      if (id) ziele[i].setAttribute('data-bk-key', String(id));
      else ziele[i].removeAttribute('data-bk-key');
    }
  }

  /* ───────── Wartezustand (nur Optik) ───────── */
  function busyAn() {
    gen += 1;
    var g = gen;
    var ziele = document.querySelectorAll('add-to-cart-component, sticky-add-to-cart');
    for (var i = 0; i < ziele.length; i++) {
      if (!ziele[i].hasAttribute('data-bk-busy')) ziele[i].setAttribute('data-bk-busy', '');
    }
    if (busyTimer) clearTimeout(busyTimer);
    busyTimer = setTimeout(function () { busyAus(g); }, BUSY_MS);
  }

  function busyAus(g) {
    if (g !== undefined && g !== gen) return;
    if (busyTimer) { clearTimeout(busyTimer); busyTimer = null; }
    var ziele = document.querySelectorAll('[data-bk-busy]');
    for (var i = 0; i < ziele.length; i++) ziele[i].removeAttribute('data-bk-busy');
  }

  /* ───────── 4.2 Schreibrunde für die Zielvariante ───────── */
  function schreibe(v) {
    var key = String(v.id);

    var form = document.querySelector('product-form-component[data-product-id="' + modell.produktId + '"]')
      || document.querySelector('product-form-component');
    var idFeld = form ? form.querySelector('input[name="id"]') : null;
    if (idFeld && idFeld.value !== key) idFeld.value = key;

    // Preis in der Kaufbox
    var pe = document.querySelector('preis-ersparnis');
    var tplP = document.querySelector('template[data-bk-preis="' + key + '"]');
    if (pe && tplP && pe.getAttribute('data-bk-key') !== key) {
      var alte = pe.querySelectorAll(':scope > .pe__oben, :scope > .pe__current');
      var anker = alte.length ? alte[0] : pe.firstChild;
      var neu = tplP.content.cloneNode(true);
      pe.insertBefore(neu, anker);
      for (var i = 0; i < alte.length; i++) alte[i].remove();
      pe.setAttribute('data-bk-key', key);
    }

    // Sticky-Leiste
    var skb = document.querySelector('sticky-add-to-cart');
    var tplS = document.querySelector('template[data-bk-skb="' + key + '"]');
    if (skb && tplS && skb.getAttribute('data-bk-key') !== key) {
      var verf = tplS.getAttribute('data-verfuegbar') === 'true';
      var zeile = skb.querySelector('.skb__preiszeile');
      if (zeile) zeile.replaceChildren(tplS.content.cloneNode(true));
      var variante = skb.querySelector('.skb__variante');
      var vt = tplS.getAttribute('data-variante') || '';
      if (variante) { setzeText(variante, vt); variante.hidden = !vt; }
      skb.setAttribute('data-variant-available', verf ? 'true' : 'false');
      var sknopf = skb.querySelector('[ref="addToCartButton"]');
      if (sknopf) {
        if (sknopf.disabled !== !verf) sknopf.disabled = !verf;
        setzeText(sknopf.querySelector('.add-to-cart-text__content > span'), verf ? 'In den Warenkorb' : 'Nicht verfügbar');
      }
      skb.setAttribute('data-bk-key', key);
    }

    // „Ihre Auswahl“ + Lagerstatus
    var avl = document.querySelector('auswahl-verfuegbarkeit');
    var tplA = document.querySelector('template[data-bk-avl="' + key + '"]');
    if (avl && tplA && avl.getAttribute('data-bk-key') !== key) {
      var klasse = tplA.getAttribute('data-klasse');
      if (klasse && avl.className !== klasse) avl.className = klasse;
      avl.replaceChildren(tplA.content.cloneNode(true));
      avl.setAttribute('data-bk-key', key);
    }

    // Kaufknopf: nur Verfügbarkeit und Beschriftung – nie „busy“ über disabled
    var knopf = form ? form.querySelector('add-to-cart-component [ref="addToCartButton"]') : null;
    if (knopf) {
      var soll = !v.verfuegbar;
      if (knopf.disabled !== soll) knopf.disabled = soll;
      if (v.kaufText) setzeErstenText(knopf, v.kaufText);
    }
  }

  /* ───────── 4.1 Größe an Schwesterprodukte weitergeben ───────── */
  function schluesselAus(optionen, werte) {
    var b = null, h = null;
    for (var i = 0; i < optionen.length && i < 3; i++) {
      var w = werte[i];
      if (w == null || w === '') continue;
      var typ = optionen[i].typ;
      if (typ === 'groesse') {
        var m = normal(w).match(/^(\d{2,3})x(\d{2,3})/);
        if (m) { b = parseInt(m[1], 10); h = parseInt(m[2], 10); }
      } else if (typ === 'breite') {
        var nb = parseInt(w, 10); if (nb) b = nb;
      } else if (typ === 'hoehe') {
        var nh = parseInt(w, 10); if (nh) h = nh;
      }
    }
    if (b && h) return { b: b, h: h };
    return null;
  }

  function sonstWerte(optionen, werte) {
    var r = {};
    for (var i = 0; i < optionen.length && i < 3; i++) {
      if (optionen[i].typ === 'sonst' && werte[i] != null) r[normal(optionen[i].name)] = normal(werte[i]);
    }
    return r;
  }

  /** Beste Variante eines Schwesterprodukts zur aktuellen Größe. Rückgabe {id, exakt} oder null. */
  function besteVariante(g, key, sonst) {
    if (!g || !g.varianten || !g.varianten.length) return null;
    var kand = [];
    for (var i = 0; i < g.varianten.length; i++) {
      var r = g.varianten[i];
      var werte = [r[1], r[2], r[3]];
      kand.push({ id: r[0], werte: werte, verf: !!r[4], key: schluesselAus(g.optionen || [], werte) });
    }
    function sonstPasst(k) {
      var eigene = sonstWerte(g.optionen || [], k.werte);
      for (var n in sonst) {
        if (eigene[n] !== undefined && eigene[n] !== sonst[n]) return false;
      }
      return true;
    }
    function waehle(liste) {
      // bevorzugt verfügbar + gleiche Zusatzoptionen, dann verfügbar, dann irgendeine
      var i;
      for (i = 0; i < liste.length; i++) if (liste[i].verf && sonstPasst(liste[i])) return liste[i];
      for (i = 0; i < liste.length; i++) if (liste[i].verf) return liste[i];
      return null;
    }
    if (!key) {
      var w0 = waehle(kand);
      return w0 ? { id: w0.id, exakt: true } : null;
    }
    var exakt = kand.filter(function (k) { return k.key && k.key.b === key.b && k.key.h === key.h; });
    var wE = waehle(exakt);
    if (wE) return { id: wE.id, exakt: true };
    // nächstliegend: gleiche Höhe und kleinste Breitenabweichung, sonst kleinste Höhen-, dann Breitenabweichung; Gleichstand → größere Fläche
    var mitKey = kand.filter(function (k) { return k.key && k.verf; });
    if (!mitKey.length) return null;
    mitKey.sort(function (x, y) {
      var dhX = Math.abs(x.key.h - key.h), dhY = Math.abs(y.key.h - key.h);
      var dbX = Math.abs(x.key.b - key.b), dbY = Math.abs(y.key.b - key.b);
      var gX = dhX === 0 ? 0 : 1, gY = dhY === 0 ? 0 : 1;
      if (gX !== gY) return gX - gY;
      if (gX === 0 && dbX !== dbY) return dbX - dbY;
      if (dhX !== dhY) return dhX - dhY;
      if (dbX !== dbY) return dbX - dbY;
      return (y.key.b * y.key.h) - (x.key.b * x.key.h);
    });
    var best = mitKey[0];
    var gleiche = mitKey.filter(function (k) { return k.key.b === best.key.b && k.key.h === best.key.h; });
    var wN = waehle(gleiche) || best;
    return { id: wN.id, exakt: false };
  }

  function geschwisterZu(handle) {
    var g = modell.geschwister || [];
    for (var i = 0; i < g.length; i++) if (g[i].handle === handle) return g[i];
    return null;
  }

  function chipsAktualisieren(v) {
    var links = document.querySelectorAll('a.pkv__chip[data-bk-handle]');
    if (!links.length) return;
    var werte = v ? [v.o1, v.o2, v.o3] : [];
    var key = v ? schluesselAus(modell.optionen, werte) : null;
    var sonst = v ? sonstWerte(modell.optionen, werte) : {};
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      var g = geschwisterZu(a.getAttribute('data-bk-handle'));
      if (!g || !g.url) continue;
      var wahl = besteVariante(g, key, sonst);
      var href = g.url;
      if (wahl) {
        href += (href.indexOf('?') >= 0 ? '&' : '?') + 'variant=' + wahl.id;
        if (key && !wahl.exakt) href += '&bk_von=' + key.b + 'x' + key.h + '&bk_art=' + (g.art === 'betriebsart' ? 'betriebsart' : 'farbe');
      }
      if (a.getAttribute('href') !== href) a.setAttribute('href', href);
    }
  }

  /* ───────── 4.1b Hinweis auf der Zielseite ───────── */
  function hinweisWeg() {
    var h = document.querySelector('[data-bk-hinweis]');
    if (h) h.remove();
  }

  function hinweisPruefen(vp) {
    var params = new URLSearchParams(window.location.search);
    var von = params.get('bk_von');
    var art = params.get('bk_art') || 'farbe';
    if (!von) return;
    // Parameter aus der URL nehmen, ?variant bleibt
    try {
      params.delete('bk_von');
      params.delete('bk_art');
      var q = params.toString();
      history.replaceState(history.state, '', window.location.pathname + (q ? '?' + q : '') + window.location.hash);
    } catch (e) {}
    var m = von.match(/^(\d{2,3})x(\d{2,3})$/);
    if (!m || !vp) return;
    var werte = auswahl(vp);
    var v = werte ? varianteZu(modell.varianten, werte) : null;
    if (!v) return;
    var key = schluesselAus(modell.optionen, [v.o1, v.o2, v.o3]);
    if (!key) return;
    var vonText = m[1] + ' x ' + m[2];
    var jetztText = key.b + ' x ' + key.h;
    if (vonText === jetztText && v.verfuegbar) return;
    // Gibt es die gewünschte Größe hier, nur ausverkauft? (Gegencheck 09.10.: die Chips verlinken nie auf ausverkaufte Varianten)
    var vonB = parseInt(m[1], 10), vonH = parseInt(m[2], 10), ausverkauft = false;
    for (var i = 0; i < modell.varianten.length; i++) {
      var k = schluesselAus(modell.optionen, [modell.varianten[i].o1, modell.varianten[i].o2, modell.varianten[i].o3]);
      if (k && k.b === vonB && k.h === vonH) { ausverkauft = true; break; }
    }
    // Beim Betriebsart-Wechsel bleibt die Farbe gleich – dann die Betriebsart nennen
    var ausfuehrung = 'bei dieser Ausführung';
    if (art === 'betriebsart' && modell.betriebsart) ausfuehrung = 'als ' + modell.betriebsart;
    else if (art !== 'betriebsart' && modell.farbe) ausfuehrung = 'in ' + modell.farbe;
    var text;
    if (vonText === jetztText) text = 'Die Größe ' + vonText + ' ist ' + ausfuehrung + ' derzeit ausverkauft.';
    else if (ausverkauft) text = 'Die Größe ' + vonText + ' ist ' + ausfuehrung + ' derzeit ausverkauft. Vorgewählt ist die nächste verfügbare Größe ' + jetztText + ' cm.';
    else text = 'Die Größe ' + vonText + ' gibt es ' + ausfuehrung + ' nicht. Vorgewählt ist die nächste Größe ' + jetztText + ' cm.';
    if (document.querySelector('[data-bk-hinweis]')) return;
    var p = document.createElement('p');
    p.className = 'bk-hinweis';
    p.setAttribute('data-bk-hinweis', '');
    p.setAttribute('role', 'status');
    p.textContent = text;
    // direkt unter den Optionen (im Picker, nach dem Formular); die Watt-Box hängt sich hinter den Picker
    vp.appendChild(p);
  }

  /* ───────── Notfall: Antwort ohne Variantenwähler (Bot-Schutz/Fehlerseite) ───────── */
  function notfall(ergebnis) {
    try {
      var d = ergebnis && ergebnis.detail;
      if (!d || d.resource !== null || !d.html || !d.html.querySelector) return;
      if (d.html.querySelector('variant-picker')) return; // echte Antwort „Kombination gibt es nicht“ → Horizon entscheidet
      var vp = picker();
      var werte = vp ? auswahl(vp) : null;
      var v = werte ? varianteZu(modell.varianten, werte) : null;
      if (!v || !v.verfuegbar) return;
      // nach den Microtasks von product-form.js (das die Variante gerade geleert/gesperrt hat)
      setTimeout(function () {
        try {
          schluesselSetzen(null);
          schreibe(v);
          var atc = document.querySelector('product-form-component add-to-cart-component');
          if (atc && typeof atc.enable === 'function') atc.enable();
          var skb = document.querySelector('sticky-add-to-cart');
          if (skb) skb.setAttribute('data-variant-available', 'true');
        } catch (e) { sicherung(e); }
      }, 0);
    } catch (e) { sicherung(e); }
  }

  /* ───────── Ereignisse ───────── */
  function beiWechsel(e) {
    if (window.__bkVM.aus || !modell) return;
    try {
      var t = e.target;
      if (!t || !(t instanceof HTMLInputElement) || t.type !== 'radio') return;
      var vp = t.closest('variant-picker');
      if (!vp || vp.getAttribute('data-template-product-match') !== 'true') return;
      if (t.closest('product-card, quick-add-dialog, dialog') || !t.closest('fieldset')) return;
      hinweisWeg();
      var werte = auswahl(vp);
      var v = werte ? varianteZu(modell.varianten, werte) : null;
      busyAn();
      if (v) schreibe(v);           // Kombination gibt es nicht → nichts schreiben, Horizon sperrt den Knopf
      else schluesselSetzen(null);  // … und die Schlüssel löschen, damit der Rückweg wieder sofort schreibt
      chipsAktualisieren(v);
    } catch (err) {
      sicherung(err);
    }
  }

  function beiSelect(e) {
    if (window.__bkVM.aus || !modell) return;
    try {
      var t = e.target;
      if (t && t.closest && t.closest('product-card, quick-add-dialog, dialog')) return;
      if (!e.promise || typeof e.promise.then !== 'function') return;
      var g = gen;
      e.promise.then(function (r) {
        busyAus(g);
        try {
          var res = r && r.detail ? r.detail.resource : undefined;
          if (res === null) schluesselSetzen(null);
          else if (res && res.id) schluesselSetzen(res.id);
        } catch (err2) {}
        notfall(r);
      }, function () { busyAus(g); });
    } catch (err) {
      sicherung(err);
    }
  }

  function start() {
    try {
      modell = lesen();
      if (!modell) return; // kein Modell → Controller bleibt vollständig passiv
      document.addEventListener('change', beiWechsel, true);
      document.addEventListener('shopify:product:select', beiSelect, true);
      var vp = picker();
      var werte = vp ? auswahl(vp) : null;
      var v = werte ? varianteZu(modell.varianten, werte) : null;
      chipsAktualisieren(v);
      hinweisPruefen(vp);
    } catch (err) {
      sicherung(err);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
